(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("9XE2R", function(module, exports) {

var $jg1Xv = parcelRequire("jg1Xv");

var $ogxQy = parcelRequire("ogxQy");
const $7408afdbe4c5bc04$var$searches = document.querySelectorAll(".--js-search");
$7408afdbe4c5bc04$var$searches.forEach((search)=>{
    const dropdown = search.querySelector(".--js-search-dropdown");
    const targetElement = search.querySelector(".--js-search-dropdown-target");
    const input = search.querySelector("input");
    if (!targetElement || !input) return;
    const fetchForm = async ()=>{
        targetElement.classList.add("--loading");
        dropdown?.classList.toggle("d-none", !input.value);
        const url = input.value ? `${search.action}?${input.value}` : search.action;
        const response = await (0, $jg1Xv.makeRequest)(url, {
            method: "GET"
        });
        targetElement.classList.remove("--loading");
        const json = await response.json();
        const data = JSON.parse(json);
        if (data.html) targetElement.innerHTML = data.html;
    };
    input.addEventListener("input", (0, $ogxQy.debounce)(fetchForm, 500));
    input.addEventListener("focus", ()=>{
        if (input.value) dropdown?.classList.remove("d-none");
    });
    document.addEventListener("click", ({ target: target })=>{
        if (target instanceof Element && !target?.closest(".--js-search")) dropdown?.classList.add("d-none");
    });
});

});
parcelRegister("jg1Xv", function(module, exports) {

$parcel$export(module.exports, "makeRequest", function () { return $e05107ecf6038ea5$export$699251e5611cc6db; });
const $e05107ecf6038ea5$export$699251e5611cc6db = async (url, options)=>{
    try {
        const response = await fetch(url, {
            ...options
        });
        console.log(response);
        if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
        return response;
    } catch (error) {
        console.error("An error occurred:", error);
        throw error; // Propagate the error for handling at a higher level if needed
    }
};

});

parcelRegister("ogxQy", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $048f137b14a33e13$export$61fc7d43ac8f84b0; });
const $048f137b14a33e13$export$61fc7d43ac8f84b0 = (fn, delay = 500)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            fn.apply(undefined, args);
        }, delay);
    };
};

});


})();
//# sourceMappingURL=async-search.686bd821.js.map
